module.exports = __webpack_public_path__ + "img/11d.41d6d66f.png";